'use client';

import { useMemo } from 'react';
import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { UIMarket } from '@drift/common';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import useMarkPrice from 'src/hooks/useMarkPrice';
import { AccountOpenPosition } from 'src/@types/positions';

interface MarkPriceCellProps {
	position: AccountOpenPosition;
}

export function MarkPriceCell({ position }: MarkPriceCellProps) {
	const { entryPrice, marketIndex, isDustPosition } = position;

	const uiMarket = UIMarket.createPerpMarket(marketIndex);
	const marketId = uiMarket.marketId;

	const markPrice = useMarkPrice(marketId);

	const priceChangePct = useMemo(() => {
		const entryNum = BigNum.from(entryPrice, PRICE_PRECISION_EXP).toNum();

		if (isDustPosition || entryNum <= 0) return '-';

		const markNum = markPrice.toNum();
		const percentNum = ((markNum - entryNum) / entryNum) * 100;

		return `(${percentNum.toFixed(2)}%)`;
	}, [entryPrice, isDustPosition, markPrice]);

	return (
		<div className="flex flex-col gap-y-xs text-left">
			<NumberDisplay
				value={markPrice}
				decimals={getMarketPriceDecimals(uiMarket.baseAssetSymbol())}
				type="currency"
			/>
			<span className="text-left typo-b4 text-text-secondary">
				{priceChangePct}
			</span>
		</div>
	);
}
